import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DefaultLayoutComponent } from './default-layout.component';
import { DefaultHeaderComponent } from './default-header/default-header.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    TranslateModule.forChild({}),
    MatToolbarModule,
    IntrackFeatureModule,
  ],
  exports: [DefaultLayoutComponent],
  declarations: [DefaultLayoutComponent, DefaultHeaderComponent],
})
export class DefaultLayoutModule {}
